module.exports = __webpack_public_path__ + "static/img/streamMedia-whyneed-img6.6aeb766.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/promotion/streamMedia-whyneed-img6.png
// module id = 1099
// module chunks = 1